import { render, staticRenderFns } from "./ManagePublicMemberships.vue?vue&type=template&id=6cfd7f3a&scoped=true"
import script from "./ManagePublicMemberships.vue?vue&type=script&lang=js"
export * from "./ManagePublicMemberships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd7f3a",
  null
  
)

export default component.exports